// extracted by mini-css-extract-plugin
export default {"sectionBoxContainer":"styles_sectionBoxContainer__4uZVe","sectionBox":"styles_sectionBox__67dG4"};